<template>
  <article class="d-flex flex-column mx-xxs-3 mt-0">
    <section class="d-flex flex-row justify-content-between">
      <h5 class="px-xxs-0 text-align-start mb-0 collection-carousel-title">
        {{ title }}
      </h5>
      <b-link :to="url" class="no-underline me-0">
        <div v-if="portalGeneralInfo.Skin === 'cloob' || portalGeneralInfo.Skin === 'jabe'" >
          <i class="left-arrow-light"/>
        </div>
        <small v-else>
          {{ $t('common.more') }}
        </small>
      </b-link>
    </section>
    <div 
      v-if="portalGeneralInfo.Skin === 'cloob' || portalGeneralInfo.Skin === 'jabe'"
      class="ml-minus"
      style="direction: ltr;">
    <Carousel
      :rtl="$store.getters['tenantConfig/isRTL']"
      :auto-width="true" 
      :margin="8" 
      :nav="false"
      :loop="false"
      :rewind="true"
      :items="listCount"
      :dots="false">
      <ProductCard v-for="(item, index) in items" :key="index" :item="item" @click='trackGaEvent(item.id)'/>
    </Carousel>
    </div>
    <div v-else style="direction: ltr;">
    <Carousel
      :rtl="$store.getters['tenantConfig/isRTL']"
      :auto-width="true" 
      :margin="8" 
      :loop="true" 
      :rewind="true"
      :items="12"
      :dots="false">
      <ProductCard v-for="(item, index) in items" :key="index" :item="item" @click='trackGaEvent(item.id)'/>
    </Carousel>
    </div>
  </article>
</template>
<style>
.owl-item {
  padding-bottom: 5px;
}
</style>
<script>

import { mapGetters } from 'vuex'
import ProductCard from '@/components/ProductCard.vue'
import Carousel from '@/components/Carousel.vue'
export default {
  name: 'SimpleCollection',
  components: {
    Carousel,
    ProductCard,
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    index:{
      type: Number,
      default:0
    }
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    },
    listCount() {
      if (window.innerWidth > 768){
        return 8
      } else if (window.innerWidth <= 768 && window.innerWidth > 540) {
        return 6
      } else {
        return 3
      }
    }
  },
  data () {
    return {
      cardWidth: ''
    }
  },
  methods: {
    trackGaEvent(itemId)
    {
      this.$ga.event('Collection', 'CollectionRow#'+this.index+'Click', itemId)
    },
    trackCollectionGaEvent()
    {
      this.$ga.event('Collection', 'CollectionRow#'+this.index+'Click')
    }
  },
}
</script>
